import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=76ded5c2&scoped=true"
import script from "./QuestionContent.vue?vue&type=script&lang=ts"
export * from "./QuestionContent.vue?vue&type=script&lang=ts"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=76ded5c2&prod&lang=scss&scoped=true"
import style1 from "./QuestionContent.vue?vue&type=style&index=1&id=76ded5c2&prod&lang=scss"
import style2 from "./QuestionContent.vue?vue&type=style&index=2&id=76ded5c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ded5c2",
  null
  
)

export default component.exports